export default function AdminPage({ canManageSettings, canManageUsers, onOpenSettings, onExport, onOpenUsers, onOpenGroups }) {
  return (
    <main className="app-shell">
      <section className="hero">
        <div className="hero-line">
          <div>
            <h1>پنل مدیریت</h1>
            <p>تنظیمات سیستم، پشتیبان‌گیری از داده‌ها و مدیریت کاربران از همین‌جا در دسترس است.</p>
          </div>
        </div>
      </section>

      <section className="groups">
        {canManageSettings && (
          <article className="person in-group">
            <div className="person-top">
              <div className="name-block">
                <div className="name">تنظیمات آستانهٔ باف</div>
                <div className="meta">تعیین می‌کند هر چند بازخورد منفی یا مثبت، یک باف محسوب شود.</div>
              </div>
            </div>
            <div className="actions">
              <button className="btn btn-primary" type="button" onClick={onOpenSettings}>⚙ باز کردن تنظیمات</button>
            </div>
          </article>
        )}

        <article className="person in-group">
          <div className="person-top">
            <div className="name-block">
              <div className="name">داده‌ها</div>
              <div className="meta">گرفتن خروجی پشتیبان از داده‌های فعلی سیستم.</div>
            </div>
          </div>
          <div className="actions">
            <button className="btn btn-soft" type="button" onClick={onExport}>خروجی داده‌ها</button>
          </div>
        </article>

        <article className="person in-group">
          <div className="person-top">
            <div className="name-block">
              <div className="name">گروه‌ها</div>
              <div className="meta">افزودن گروه جدید یا تغییر نام و حذف گروه‌ها.</div>
            </div>
          </div>
          <div className="actions">
            <button className="btn btn-primary" type="button" onClick={onOpenGroups}>👥 مدیریت گروه‌ها</button>
          </div>
        </article>

        {canManageUsers && (
          <article className="person in-group">
            <div className="person-top">
              <div className="name-block">
                <div className="name">کاربران و دسترسی‌ها</div>
                <div className="meta">افزودن کاربر، تعیین سطح دسترسی و مدیریت دسترسی گروه‌ها.</div>
              </div>
            </div>
            <div className="actions">
              <button className="btn btn-primary" type="button" onClick={onOpenUsers}>👤 مدیریت کاربران</button>
            </div>
          </article>
        )}
      </section>
    </main>
  );
}
